const visibleToolArgumentKeys: Record<string, readonly string[]> = {
  search_course_sections: ['query', 'department', 'campus', 'semester', 'openOnly', 'limit'],
  search_skills: ['query'],
  read_skill: ['skillId', 'version'],
  search_tools: ['query', 'skillId'],
  execute_capability: ['capabilityId'],
  search_web: ['query', 'officialOnly'],
  preview_webpage: ['url'],
  generate_schedule_options: ['courseBaseIds', 'semester', 'earliestStartMinute', 'latestEndMinute', 'preferredCampuses', 'openOnly', 'maxSchedules'],
};

export function visibleAssistantToolArguments(toolName: string, args: unknown): Record<string, unknown> | null {
  if (!args || typeof args !== 'object' || Array.isArray(args)) return null;
  const allowed = visibleToolArgumentKeys[toolName];
  if (!allowed) return null;
  const record = args as Record<string, unknown>;
  const visible = Object.fromEntries(allowed.flatMap((key) => key in record ? [[key, record[key]]] : []));
  return Object.keys(visible).length ? visible : null;
}

